import React, { Fragment } from "react";
import { skill } from "../data";

const Skills = () => {
  return (
    <section className="jumbotron2 row add_zindex">
      <div id="Skills" className="first1"></div>
      <div className="mb-4 col-lg-4 center-content" data-aos="fade-down">
        <h2 className="underline skills__topic">SKILLS</h2>
      </div>
      <div className="col-lg-8 col-md-12">
        {skill.map((item, index) => (
          <Fragment key={index}>
            <div className="center-content">
              <h4
                className="skills__title"
                data-aos="fade-down"
                data-aos-delay="200"
              >
                {item.title}
              </h4>
            </div>
            {item.data.map((nestedItem, nestedIndex) => (
              <div
                key={nestedIndex}
                className="skills__data"
                data-aos="fade-down"
                data-aos-delay="200"
              >
                <div className="skills__data1">
                  <div className="skills__names">
                    <i className="skills__icon">
                      <img
                        src={nestedItem.imgUrl}
                        alt={nestedItem.title}
                        title={nestedItem.title}
                        className={nestedItem.imageCName}
                        draggable="false"
                      />
                    </i>
                    <span className="skills__name">{nestedItem.title}</span>
                  </div>
                  <div className={`skills__bar ${nestedItem.className}`}></div>
                  <div>
                    <span className="skills__percentage">
                      {nestedItem.percentage}%
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    </section>
  );
};

export default Skills;
